import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { AppService, BASE_URL_SSO, REALM, BASE_URL_KASTOR, BASE_URL_CRUD } from '../app.service';
import { map } from 'rxjs/operators';


@Injectable()
export class AuthenticationService extends AppService {

  static kastorURL(path): string {
    return `${BASE_URL_KASTOR}${path}`;
  }

  static kiungoURL(path): string {
    return `${BASE_URL_KASTOR}${path}`;
  }

  constructor(http: HttpClient) {
    super(http);
  }

  login(email: string, password: string): Observable<any> {
    this.endpoint = `${BASE_URL_SSO}/login`;
    return this.createSSO(this.endpoint, { email: email, password: password, realm: REALM });
  }

  impersonate(email: string, realm: string): Observable<any> {
    this.endpoint = `${BASE_URL_SSO}/impersonate`;
    return this.create(this.endpoint, { email: email, realm: realm });
  }

  selectCommunity(communityId, token): Observable<any> {
    this.endpoint = `${BASE_URL_SSO}/community/set`;
    return this.create(this.endpoint, { community_id: communityId });
  }

  check(token: string): Observable<any> {
    this.endpoint = `${BASE_URL_SSO}/check`;
    return this.get(this.endpoint);
  }

  reset(username: string): Observable<any> {
    this.endpoint = `${BASE_URL_SSO}/reset`;
    return this.create(this.endpoint, { username: username, realm: REALM });
  }

  restore(username: string, password: string, token: string): Observable<any> {
    this.endpoint = `${BASE_URL_SSO}/reset/${token}`;
    return this.create(this.endpoint, { username: username, password: password, realm: REALM });
  }

  public getUserById(userId: any) {
    this.endpoint = `${BASE_URL_CRUD}/users/${userId}`;
    return this.get(this.endpoint).pipe( map(res => {
      const user = res;
      return `${user.name} ${user.lastname}`
    }));
  }

  logout(token: string): Observable<any> {
    // remove user from local storage to log user out
    this.endpoint = `${BASE_URL_SSO}/logout`;
    return this.get(this.endpoint);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/authentication.service.ts